import { useSyncExternalStore } from 'react';
import { subscribeDownloadToken, getDownloadTokenSnapshot } from '@lib/apiClient';

/**
 * useDownloadToken — subscribe to the warmed download token so this component
 * re-renders (and any assetUrl()-built href / src it holds refreshes) when the
 * token first lands after a cold load OR rotates on the warm interval. Returns
 * the current token, or null when the bearer is disabled (flag-off), in which
 * case it stays null forever and is a harmless no-op.
 *
 * Asset-bearing pages call this so auto-loading media (img/video/audio) never
 * paints a token-less src before the first warm resolves, and so a long-mounted
 * page's download anchors never carry an expired token after the 5-minute TTL.
 */
export function useDownloadToken(): string | null {
  return useSyncExternalStore(
    subscribeDownloadToken,
    getDownloadTokenSnapshot,
    getDownloadTokenSnapshot,
  );
}
